import { render, staticRenderFns } from "./toMatchOrder.vue?vue&type=template&id=55d7b912&scoped=true"
import script from "./toMatchOrder.vue?vue&type=script&lang=js"
export * from "./toMatchOrder.vue?vue&type=script&lang=js"
import style0 from "./toMatchOrder.vue?vue&type=style&index=0&id=55d7b912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7b912",
  null
  
)

export default component.exports